<template>
  <div class="status-banner">
    <div class="status-banner__header">
      <slot name="header"></slot>
    </div>
    <div class="status-banner__subhead">
      <slot name="subhead"></slot>
    </div>
    <div class="status-banner__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
